/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MachineLimitRule { 
    id?: string;
    variableId?: string;
    thresholdValue?: number;
    hysteresis?: number;
    machineState?: string;
    operator?: string;
    appScope?: MachineLimitRule.AppScopeEnum;
    enabled?: boolean;
    lastEventAt?: string;
}
export namespace MachineLimitRule {
    export const AppScopeEnum = {
        IpsepmonLowAlarmLimit: 'ipsepmon/lowAlarmLimit',
        IpsepmonPreAlarmLimit: 'ipsepmon/preAlarmLimit',
        IpsepmonHighAlarmLimit: 'ipsepmon/highAlarmLimit'
    } as const;
    export type AppScopeEnum = typeof AppScopeEnum[keyof typeof AppScopeEnum];
}


